import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import {
  useEmailCreationFormInitialValues,
  useEmailGetActiveAccountForCreate,
} from '../../../../Email'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { RequestProfileEmailAudienceModal } from '../../../RequestProfileEmailAudienceModal'
import {
  EMAIL_AUDIENCE_BY_RECIPIENT_TYPE,
  RequestProfileTabEmailsCreateEmailPopUp,
} from '../../../RequestProfileTabEmails'
import { getRequestProfileActionsWidgetCreateEmailInitialValues } from '../../RequestProfileActionsWidget.utils'

export function useRequestProfileActionsWidgetCreateEmailAction() {
  const {
    handleCloseModal,
    handleReloadAfterChange,
    requestContractors,
    requestData,
    setModal,
  } = useRequestProfileContext()

  const { activeAccountForCreate } = useEmailGetActiveAccountForCreate({
    withServiceAccount: true,
  })

  const emailInitial = useEmailCreationFormInitialValues({
    account: activeAccountForCreate,
  })

  async function handleReloadAfterSend() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.emails)
  }

  function handleSubmitAudience({ recipientType }) {
    setModal(
      <RequestProfileTabEmailsCreateEmailPopUp
        audience={EMAIL_AUDIENCE_BY_RECIPIENT_TYPE[recipientType]}
        initialValues={getRequestProfileActionsWidgetCreateEmailInitialValues({
          emailInitial,
          recipientType,
          requestContractors,
          requestData,
        })}
        requestData={requestData}
        requestId={requestData?.id}
        onClose={handleCloseModal}
        onSendSuccess={handleReloadAfterSend}
      />
    )
  }

  function handleClickCreateEmail() {
    setModal(
      <RequestProfileEmailAudienceModal
        onClose={handleCloseModal}
        onSubmit={handleSubmitAudience}
      />
    )
  }

  return { handleClickCreateEmail }
}
